import { userData } from './functions'

/**
 * retorna se usuário tem permissão /action/ em /target/
 * @param {("read"|"write"|"edit"|"remove")} action ação
 * @param {string} target target 
 * @returns {boolean} true se autorizado
 */
const permission = (action, target) => {
    if (!action || !target) return false;

    let { permissions } = userData();
    return (permissions && permissions[target] && permissions[target][action]) ? true : false;
}

export default permission;